import { DateFormats } from 'UI/constants/defaults';

export const DEFAULT_INTERVAL_MINUTES = 15;

export const MINUTES_IN_DAY = 24 * 60;

export const TIME_OPTION_ID_FORMAT = DateFormats.SimpleTime24Format;

export const TIME_OPTION_LABEL_FORMAT = DateFormats.SimpleTime;

export const TIME_OPTION_ID_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
